import { useSyncExternalStore } from "react"

import { prismMemorySnapshot, subscribeMemoryBackend } from "@/stores/memory-backend-store"

/** The deployment config is immutable; an absent field means legacy. */
export function usePrismMemory(): boolean {
  return useSyncExternalStore(subscribeMemoryBackend, prismMemorySnapshot, () => false)
}
